import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./error-page.css";
export default function Error401() {
  const { t } = useTranslation(["common"]);
  return (
    <div>
      <div className="error-container error-page bg-primary pt-5 pb-4">
        <div className="container-fluid ">
          <div className="col-lg-8 mx-auto text-white">
            <div className="row align-items-center d-flex flex-row">
              <div className="col-lg-6 error-page-divider text-lg-left pl-lg-4">
                <h2>{t("error.default", { ns: "common" })}</h2>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-12 text-center mt-xl-2">
                <Link className="text-white font-weight-medium" to="/">
                  {t("label.home", { ns: "common" })}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
